/* eslint-disable max-len */
export const ACCEPTED_FILE_MIME_TYPES = [
  'application/pdf',
  'audio/mpeg',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'text/html',
  'text/plain',
];

export const DOC_UPLOAD_BANNER_ERROR_MESSAGES = {
  '27000.1000': 'Sorry! This file type is not accepted.',
  27000.1002: 'Image size exceeds 10 MB.',
  27000.1003: 'Maximum of 5 documents allowed. To add another, please remove one or more attachments.',
  default: 'Something unexpected happened. Please try again.',
};

export const DOC_UPLOAD_ERROR_MESSAGES = {
  '27000.1000': 'Must be one of the following file types: .gif, .jpeg, .jpg, .pdf, .png, .tif, .tiff',
  // 27000.1001: 'Document Category is invalid', // Not user's fault. Should be treated as 500 error
  27000.1002: 'Image size exceeds 10 MB.',
  27000.1003: 'Maximum of 5 documents allowed. To add another, please remove one or more attachments.',
};

export const ACCEPTABLE_REASON_CODES = ['27000.999999', '27001.2000', '27001.2001'];

export const FILE_TYPE_REASON_CODE = '27000.1000';
export const MAX_FILE_SIZE = '10485760';
export const MAX_FILE_SIZE_REASON_CODE = '27000.1002';
export const MAX_FILES_REASON_CODE = '27000.1003';
